module.exports = __webpack_public_path__ + "static/bg-chalk-089dc678f4383971974a5673855829e9.jpg";